import { Component } from '@angular/core';

@Component({
  selector: 'app-cards7-examples-46',
  templateUrl: './cards7-examples-46.component.html'
})
export class Cards7Examples46Component {}
